import { createSlice } from "@reduxjs/toolkit";
import { setSessionStorage } from "../../../utils/storage";

const isErrorObject = (obj) =>
    typeof obj === 'object' &&
    obj !== null &&
    !Array.isArray(obj) &&
    'errorCode' in obj &&
    'errorMessage' in obj &&
    'errorStatusCode' in obj;

const handleGenericError = (payload) => {
    let genericMessage = 'generating SSS Payment Reference Number'
    let errorResult = null
    if(isErrorObject(payload.result)){
        errorResult = payload.result
    }else{
        switch (payload.requestType) {
            case 'MEMBERSHIP_TYPE':
                genericMessage = "fetching payment types"
                break;
            case 'CONTRIBUTIONS':
                genericMessage = "fetching contributions"
                break;
            case 'PRN_DATA':
                genericMessage = 'generating SSS Payment Reference Number'
                break;
        }
        errorResult = {
                errorCode: "API3_ERROR_SSS_PRN",
                errorMessage:
                    `SSS PRN Generation - We encountered a problem while ${genericMessage}. Kindly retry to generate in a few minutes.`,
                errorStatusCode: 500,
            }
    }
    return errorResult;
}

const applyErrorState = (state, payload) => {
    state.error = handleGenericError(payload);
    state.prnData = null;
    state.isLoading = false;
    state.requestType = null;
};

const isApiErrorResponse = (data) =>
  data && typeof data === 'object' &&
  'status' in data &&
  data.status >= 400;


const initialState = {
    requestBody: {},
    membershipTypes: [],
    contributions: [],
    requestType: null,
    latestValidFrom : null,
    prnData: null,
    isLoading: false,
	error: null,
};

const prnGenerator = createSlice({
    name: "prnGenerator",
    initialState,
    reducers: {
        prep: (state, payload) => {
            state.requestBody = payload.requestBody
            state.requestType = payload.requestType
            state.isLoading = true;
            state.error = null;
        },
        setMembershipTypes: (state, payload) => {
            state.membershipTypes = payload.result.data;
            state.prnData = null
            state.contributions = []
            state.isLoading = false;
            state.error = null;
            state.requestType = null
        },
        setContributions: (state, payload) => {
            state.contributions = payload.result.data;
            state.prnData = null
            state.isLoading = false;
            state.error = null;
            state.requestType = null
        },
        setPrnData: (state, payload ) => {
            const data = payload.result.data;
            if (isApiErrorResponse(data)) {
                applyErrorState(state, payload);
            } else {
                state.prnData = data;
                state.prnData.requestBody = payload.requestBody;
                state.isLoading = false;
                state.error = null;
                state.requestType = null;
            }
        },
        setLatestValidFrom: (state, payload) => {
            state.latestValidFrom = payload.result.data;
            setSessionStorage("SSSPRNLatestValidFrom", payload.result.data);
            state.prnData = null
            state.contributions = []
            state.isLoading = false;
            state.error = null;
            state.requestType = null
        },
        error: (state, payload) => {
            applyErrorState(state, payload);
        }
    },
});

const {
    prep,
    error,
    setMembershipTypes,
    setContributions,
    setPrnData,
    setLatestValidFrom
} = prnGenerator.actions;

const getMembershipTypes = async (client, state) => {
    return await client.post("/v3/sss-prn/member-types", state.prnGenerator.requestBody) 
}

const getContributions = async (client, state) => {
    return await client.post("/v3/sss-prn/contributions", state.prnGenerator.requestBody) 
}

const getPrnData = async (client, state) => {
    return await client.post("/v3/sss-prn/generator", state.prnGenerator.requestBody)
}

const getLatestValidFrom = async (client) => {
    return await client.get("/v3/sss-prn/latest-valid-from")
}

const getMembershipTypesAction = (requestBody) => {
    const requestType = "MEMBERSHIP_TYPE"
    return {
        types: [prep.type, setMembershipTypes.type, error.type],
        promise: getMembershipTypes,
        requestBody,
        requestType
    };
}

const getContributionsAction = (requestBody) => {
    const requestType = "CONTRIBUTIONS"
    return {
        types: [prep.type, setContributions.type, error.type],
        promise: getContributions,
        requestBody,
        requestType
    };
}

const getPrnDataAction = (requestBody) => {
    const requestType = "PRN_DATA"
    return {
        types: [prep.type, setPrnData.type, error.type],
        promise: getPrnData,
        requestBody,
        requestType
    };
}

const getLatestValidFromAction = () => {
    const requestType = "LATEST_VALID_FROM"
    return {
        types: [prep.type, setLatestValidFrom.type, error.type],
        promise: getLatestValidFrom,
        requestType
    };
}

export default prnGenerator.reducer;

export {
    getMembershipTypesAction,
    getContributionsAction,
    getPrnDataAction,
    getLatestValidFromAction
};
